import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableFooter, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import moment from "moment";
import StatusChip from "../../../../component/ui/chip/status";
import AvatarProfile from "../../../../component/ui/profile";
import { KPI, TitleHeading } from "../../../../component/ui/layout";
import { Skeleton } from "@mui/material";
import { Users } from "lucide-react";
import XCloseIcon from "../../../../component/icons/x-close";
import { useParams, useSearchParams } from "react-router";
import { DateRange } from "../../../../component/icons/filter-icon";

const InsightMatrices = () => {
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState({});
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-ppc-product-insight-matrices${extraUrl}`,
      });
      setList(res);
      // setTableHeaders(res.headers);
      // setSaveFilter(res?.custom_filters);
      // setFooter(res?.footer)
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateRange
    }
  ];

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className="flex items-center justify-between">

          <TableFilterReturn
            filterReturn={(!filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length) ?
              [
                {
                  "name": "date_range",
                  "label": "Date Range",
                  "selectedOpt": "is",
                  "value": lists?.date_filter,
                  "isCrossDisable": true
                },
                ...filterReturn
              ]
              : filterReturn
            }
            onChange={(filters) => {
              console.log("filtersfiltersfilters", filters)
              setFilterReturn(filters);
              getData({ filter: filters });
            }}
          />

          <div className={Style.bpfl_action}>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
          </div>

        </div>
        {/* <div className={Style.report_table__header}>
          <TitleHeading title={``} />

          <div className={Style.bpfl_action}>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
          </div>
        </div> */}

        <TableCard className={"!p-[15px] !pt-[20px] !pr-[7px] h-full overflow-hidden"}>
          {/* <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">
            {!isLoading ? (
              <>
                {lists?.quick_decisions?.map((eachQues, i) => (
                  <KPI
                    extraClass={i==0 ? "green" : i == 1 ? "yellow" : ""}
                    key={i}
                    label={eachQues?.question}
                    value={eachQues?.answer}
                    sublabel={eachQues?.action}
                  />
                ))}
              </>
            ) : (
              Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="bg-white shadow rounded-xl p-4 animate-pulse">
                  <div className="flex items-center justify-between mb-2">
                    <Skeleton variant="text" width={80} height={16} />
                    <Skeleton variant="circular" width={20} height={20} />
                  </div>
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <Skeleton variant="text" width={60} height={32} />
                    <Skeleton variant="rounded" width={40} height={20} />
                  </div>
                  <Skeleton variant="text" width={80} height={12} />
                </div>
              ))
            )}
          </div> */}
          <div className="grid grid-cols-2 gap-4 pt-5">
            <div className="flex flex-col">
              <div className="pb-4">
                <TitleHeading title={'Platform Device ROAS'} />
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : !lists?.platform_device_roas?.body?.length ? (
                <div className="w-full h-full flex items-center justify-center">
                  <DataNotFound title={"Data"} />
                </div>
              ) : (
                <>
                  <TableCard>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {lists?.platform_device_roas?.header?.map((eachHead, i) => 
                            <TableCell header><TableHeaderWrap className={"capitalize"}>{eachHead}</TableHeaderWrap></TableCell>
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.platform_device_roas?.body?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`}>
                              {lists?.platform_device_roas?.header?.map((eachHead, i) => 
                                <TableCell className={"capitalize"}>
                                  {
                                    eachList?.[eachHead] ?? "-"
                                  }
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableCard>
                </>
              )}
            </div>

            <div className="flex flex-col">
              <div className="pb-4">
                <TitleHeading title={'Product Device ROAS'} />
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : !lists?.product_device_roas?.body.length ? (
                <div className="w-full h-full flex items-center justify-center">
                  <DataNotFound title={"Data"} />
                </div>
              ) : (
                <>
                  <TableCard>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {lists?.product_device_roas?.header?.map((eachHead, i) => 
                            <TableCell header><TableHeaderWrap className={"capitalize"}>{eachHead}</TableHeaderWrap></TableCell>
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.product_device_roas?.body?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`}>
                              {lists?.product_device_roas?.header?.map((eachHead, i) => 
                                <TableCell className={"capitalize"}>
                                  {
                                    eachList?.[eachHead] ?? "-"
                                  }
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableCard>
                </>
              )}
            </div>

            <div className="flex flex-col">
              <div className="pb-4">
                <TitleHeading title={'Product Platform ROAS'} />
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : !lists?.product_platform_roas?.body?.length ? (
                <div className="w-full h-full flex items-center justify-center">
                  <DataNotFound title={"Data"} />
                </div>
              ) : (
                <>
                  <TableCard>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {lists?.product_platform_roas?.header?.map((eachHead, i) => 
                            <TableCell header><TableHeaderWrap className={"capitalize"}>{eachHead}</TableHeaderWrap></TableCell>
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.product_platform_roas?.body?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`}>
                              {lists?.product_platform_roas?.header?.map((eachHead, i) => 
                                <TableCell className={"capitalize"}>
                                  {
                                    eachList?.[eachHead] ?? "-"
                                  }
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableCard>
                </>
              )}
            </div>

            <div className="flex flex-col">
              <div className="pb-4">
                <TitleHeading title={'Spend Allocation Product Platform'} />
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : !lists?.spend_allocation_product_platform?.body?.length ? (
                <div className="w-full h-full flex items-center justify-center">
                  <DataNotFound title={"Data"} />
                </div>
              ) : (
                <>
                  <TableCard>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {lists?.spend_allocation_product_platform?.header?.map((eachHead, i) => 
                            <TableCell header><TableHeaderWrap className={"capitalize"}>{eachHead}</TableHeaderWrap></TableCell>
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.spend_allocation_product_platform?.body?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`}>
                              {lists?.spend_allocation_product_platform?.header?.map((eachHead, i) => 
                                <TableCell className={"capitalize"}>
                                  {
                                    eachList?.[eachHead] ?? "-"
                                  }
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableCard>
                </>
              )}
            </div>
          </div>
        </TableCard>
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-brand-performance-analysis"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
          }}
          apiUrl="get-brand-performance-analysis"
        />
      )}
    </>
  );
};

export default InsightMatrices;
